(function(){
     'use strict';

     angular
        .module('app')
        .factory('CitaService', CitaService);

    CitaService.$inject = ['$http'];

    function CitaService($http){
        
        var service= {
            CitaPau_Login:CitaPau_Login,
            CitaPau_Paus:CitaPau_Paus,
            CitaPau_Calendario_Dias:CitaPau_Calendario_Dias,
            CitaPau_Calendario_Horas:CitaPau_Calendario_Horas,
            CitaPau_Guardar_Cita:CitaPau_Guardar_Cita,
            CitaPau_Imprimir_Cita:CitaPau_Imprimir_Cita,
            CitaPau_Eliminar_Cita:CitaPau_Eliminar_Cita,
            login : {
                  "LlaveDeUso":"2022WebOxigen",
                  "Nombre":"",
                  "Año":"",
                  "Idioma":lang_id,
                  "CodigoCita":CodigoCita

              },
              paus :
              {
                   "LlaveDeUso":"2022WebOxigen",
                   "CodigoTratamiento":"",
                   "Idioma":lang_id
              },
              listaPaus : [],
              listaHoras: [],
              pauSelected : null,
              map:"https://mapes.oxigensalud.com/web_oxigensalud/solicitudcitapau?latitud=41.631778&longitud=-4.709407",
              calendario :
              {
                    "LlaveDeUso":"2022WebOxigen",
                    "Pau":"",
                    "Idioma":lang_id
              },
              horas :
              {
                    "LlaveDeUso":"2022WebOxigen",
                        "Pau":"",
                        "Dia":"",
                        "Idioma":lang_id
              },
              guardar_cita :
              {
                      "LlaveDeUso":"2022WebOxigen",
                      "Pau":"",
                      "Dia":"",
                      "Hora":"",
                      "Email":"",
                      "Comentario":"",
                      "Idioma":lang_id,
                      "CodigoTratamiento":""
              },
              imprimir_cita :
              {
                      "LlaveDeUso":"2022WebOxigen",
                      "CodigoCita":"",
                      "Idioma":lang_id
              },
              eliminar_cita :
              {
                      "LlaveDeUso":"2022WebOxigen",
                      "CodigoCita":"",
                      "Idioma":lang_id
              }

            };


            function CitaPau_Login(vm){
               
                return $http.post('/ajax/login', {
                    data:vm.login                
                 })
                .then(function(data){
                    return data.data;
                },function(data){
                    return data;
                });
            };
           	
     		function CitaPau_Paus(vm){
               
                return $http.post('/ajax/paus', {
                    data:vm.paus,
                    // slugAppointment:vm.slugAppointment               
                 })
                .then(function(data){
                    return data.data;
                },function(data){
                    return data;
                });
            };

            function CitaPau_Calendario_Dias(vm){
               
                return $http.post('/ajax/calendario', {
                    data:vm.calendario                
                 })
                .then(function(data){
                    return data.data;
                },function(data){
                    return data;
                });
            };

            function CitaPau_Calendario_Horas(vm){
               
                return $http.post('/ajax/horas', {
                    data:vm.horas                
                 })
                .then(function(data){
                    return data.data;
                },function(data){
                    return data;
                });
            };

            function CitaPau_Guardar_Cita(vm){
               
                return $http.post('/ajax/guardar', {
                    data:vm.guardar_cita                
                 })
                .then(function(data){
                    return data.data;
                },function(data){
                    return data;
                });
            };

            function CitaPau_Imprimir_Cita(vm){
               
                return $http.post('/ajax/imprimir', {
                    data:vm.imprimir_cita                 
                 })
                .then(function(data){
                    return data.data;
                },function(data){
                    return data;
                });
            };

            function CitaPau_Eliminar_Cita(vm){
               
                return $http.post('/ajax/eliminar', {
                    data:vm.eliminar_cita                  
                 })
                .then(function(data){
                    return data.data;
                },function(data){
                    return data;
                });
            };
           	
            return service;
        }

     
})();